<template>
    <div>
        <div class="chat-main-area-dark">
            <header class="chat-header-full-dark">
                <h2><span class="gradient-text">Chat com DirecionaTech IA</span></h2>
                <span class="clear-chat" @click="messages = messages.filter(m => m.role === 'system')">Limpar
                    chat</span>
            </header>
            <div class="chat-messages-full-dark">
                <div v-for="(msg, idx) in messages" :key="idx" :class="msg.role">
                    <div v-if="msg.role !== 'system'">
                        <strong>{{ msg.role === 'user' ? 'Você' : 'DirecionaTech IA' }}:</strong>
                        <span class="msg" v-html="renderMarkdown(msg.content)"></span>
                    </div>
                </div>
            </div>
            <div v-if="loading" class="loading-wrapper-dark">
                <div class="loader"></div>
                <span>Pensando...</span>
            </div>
            <form @submit.prevent="sendMessage" class="chat-form-full-dark">
                <input v-model="userInput" placeholder="Digite sua mensagem..." autocomplete="off" />
                <button type="submit" :disabled="loading || !userInput">Enviar</button>
            </form>
        </div>
    </div>
</template>

<script>
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default {
    name: 'ChatPage',
    data() {
        return {
            messages: [
                {
                    role: 'system',
                    content: 'Você é DirecionaTech IA, um agente de inteligência artificial especialista em soluções inovadoras para negócios. Sua missão é ajudar empresas a automatizarem processos, aumentarem a eficiência e alcançarem o sucesso. Você atua como consultor estratégico, oferecendo ideias práticas, orientações e estratégias para alavancar startups, pequenas e médias empresas, sempre com foco em crescimento, inovação e resultados.'
                }
            ],
            userInput: '',
            loading: false,
            error: null,
        };
    },
    created() {
        // Bearer token check
        const token = localStorage.getItem('bearerToken');
        if (!token) {
            this.$router.replace('/');
            return;
        }
        const saved = localStorage.getItem('direciona-ia-chat');
        if (saved) {
            try {
                this.messages = JSON.parse(saved);
            } catch (e) {
                console.error('Erro ao carregar mensagens salvas:', e);
            }
        } else {
            // Save initial system message
            localStorage.setItem('direciona-ia-chat', JSON.stringify(this.messages));
        }
    },
    watch: {
        messages: {
            handler(val) {
                localStorage.setItem('direciona-ia-chat', JSON.stringify(val));
            },
            deep: true
        }
    },
    methods: {
        renderMarkdown(text) {
            if (!text) return '';
            const html = marked.parse(text, { breaks: true });
            return DOMPurify.sanitize(html);
        },
        async sendMessage() {
            if (!this.userInput) return;
            const userMsg = { role: 'user', content: this.userInput };
            this.messages.push(userMsg);
            this.$nextTick(() => {
                const chatMessages = this.$el.querySelector('.chat-messages-full-dark');
                if (chatMessages) chatMessages.scrollTop = chatMessages.scrollHeight;
            });
            this.loading = true;
            this.error = null;
            try {
                this.userInput = '';
                const response = await this.$axios.post('https://text.pollinations.ai/openai', {
                    model: "openai",
                    messages: this.messages.map(m => ({ role: m.role, content: m.content })),
                }, {
                    headers: { 'token': 'ZpSKz_1Busi4JOFA' }
                });
                const aiMsg = response.data.choices?.[0]?.message?.content || 'Sem resposta.';
                this.messages.push({ role: 'assistant', content: aiMsg });
                this.$nextTick(() => {
                    const chatMessages = this.$el.querySelector('.chat-messages-full-dark');
                    if (chatMessages) chatMessages.scrollTop = chatMessages.scrollHeight;
                });
            } catch (e) {
                this.error = 'Erro ao conectar com a IA.';
            } finally {
                this.loading = false;
                this.userInput = '';
            }
        },
    }
};
</script>

<style scoped>
.chat-main-area-dark {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 25px;
    /* leave space for sidebar */
    padding-top: 50px;
    z-index: 2;
    box-sizing: border-box;
    background: linear-gradient(120deg, #fff7e6 0%, #ffe0b2 100%);
}

.chat-header-full-dark {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    padding: 0 24px;
}

.gradient-text {
    background: linear-gradient(90deg, #ff9800 20%, #b15205 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}

.chat-messages-full-dark {
    flex: 1;
    background: linear-gradient(120deg, #fff7e6 0%, #ffe0b2 100%);
    border-radius: 0;
    box-shadow: 0 2px 4px #0008;
    border-radius: 8px;
    padding: 24px 24px 12px 24px;
    margin-bottom: 18px;
    min-height: 220px;
    max-height: calc(100vh - 220px);
    overflow-y: auto;
    width: 100%;
    box-sizing: border-box;
}

.msg {
    color: #1f1f1f;
    margin-bottom: 8px;
}

.user {
    text-align: right;
    color: #ce6612;
}

.assistant {
    text-align: left;
    color: #884b06;
}

.chat-form-full-dark {
    display: flex;
    gap: 8px;
    width: 100%;
    margin-top: 8px;
}

input {
    flex: 1;
    padding: 12px 7px;
    border-radius: 6px;
    border: 1px solid #333;
    background: #232323;
    color: #ff9800;
    font-size: 1.08rem;
}

input::placeholder {
    color: #b0bec5;
}

button {
    background: linear-gradient(90deg, #ff9800 0%, #b15205 100%);
    color: #fff;
    border: none;
    padding: 12px 7px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    font-size: 1.08rem;
    transition: background 0.2s, transform 0.2s;
}

button:disabled {
    background: #b0bec5;
    cursor: not-allowed;
}

.loading-wrapper-dark {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #ff9800;
    margin-top: 10px;
    padding-left: 24px;
}

.loader {
    border: 4px solid #333;
    border-top: 4px solid #ff9800;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.clear-chat {
    color: #ff9800;
    cursor: pointer;
    font-size: 0.98rem;
    transition: color 0.2s;
}

.clear-chat:hover {
    color: #b15205;
    text-decoration: underline;
}
</style>
